import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "multi-columns-icon",
  role: "img",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M3.33333 1.5C2.32052 1.5 1.5 2.32052 1.5 3.33333V12.6667C1.5 13.6795 2.32052 14.5 3.33333 14.5H12.6667C13.6795 14.5 14.5 13.6795 14.5 12.6667V3.33333C14.5 2.32052 13.6795 1.5 12.6667 1.5H3.33333ZM3.33333 2.5C2.87281 2.5 2.5 2.87281 2.5 3.33333V12.6667C2.5 13.1272 2.87281 13.5 3.33333 13.5H5.5V2.5H3.33333ZM6.5 2.5V13.5H9.5V2.5H6.5ZM10.5 2.5V13.5H12.6667C13.1272 13.5 13.5 13.1272 13.5 12.6667V3.33333C13.5 2.87281 13.1272 2.5 12.6667 2.5H10.5Z"
    }, null, -1)
  ])))
}
export default { render: render }